module.exports = __webpack_public_path__ + "static/media/trophyCorrect.aaae9306.png";